/**
 * 用户相关接口
 */

import request from "@/utils/request";
import axios from "axios";

// 登录获取诊所
export function login(data) {
    return request({
        url: "/login/login-tenant-list",
        method: "post",
        data
    })
};

// 登录诊所
export function loginClinic(tenantid, userid) {
    return request({
        url: `/login/login-tenant/${tenantid}/${userid}`,
        method: "post",
    })
}

// 获取验证码 - 旧（弃用）
export function sendSmsWithLogin(data) {
    return axios({
        url: "http://njtingwang.com:20000/api/SMSSend/SendSmsWithLogin",
        method: "post",
        data
    })
}

// 获取验证码 - 新
export function sendSmsWithLoginNew(data) {
    return axios({
        url: "/login/send-sms-with-login",
        method: "post",
        data
    })
}

//  手机号对比验证码
export function contrastCode(data) {
    return axios({
        url: "/login/contrast-code",
        method: "post",
        data
    })
}

// 根据手机号验证码登录获取诊所
export function loginWithSms({ mobile, key }) {
    return request({
        url: `/login/login-tenant-list-by-mobile/${mobile}/${key}`,
        method: "post",
    })
}

// 根据手机号查询用户是否存在
export function getUserByMobile(data) {
    return request({
        url: `/user-info/user-info-by-mobile`,
        method: "post",
        data
    })
}

// 忘记密码时通过手机号修改密码
export function updatePasswordByMobile(mobile, password) {
    return request({
        url: `/login/password-by-mobile/${mobile}/${password}`,
        method: "post",
    })
}

// 根据用户ID查询诊所列表
export function getTenantListByUserId(userid) {
    return request({
        url: `/login/login-tenant-list-by-user-id/${userid}`,
        method: "get",
    })
}

// 修改密码
export function updatePassword(oldpass, newpass) {
    return request({
        url: `/login/password/${oldpass}/${newpass}`,
        method: "post"
    })
}

// 根据用户id查询菜单
export function getMenuByUserId(userid) {
    return request({
        url: `/user-info/login-user-permission/${userid}`,
        method: "get"
    })
}

// signalr接口
export function sendMessage() {
    return request({
        url: "/chat-hub/send-message/123",
        method: "post"
    })
}